export default __webpack_public_path__ + "static/media/premium-illu-bg.2194cb25.png";